module.exports = __webpack_public_path__ + "img/pic_14.3fc19105.jpg";